// extracted by mini-css-extract-plugin
module.exports = {"unusedCarouselSpace":"92px","Fallback":"_2Hf1vx","fadeInFrames":"_3O8edN"};